<template>
  <nav
    class="pagination"
    role="navigation"
    aria-label="pagination"
    v-if="visible"
  >
    <router-link
      :to="{ name: viewName, params: { id: previous } }"
      :disabled="previous ? false : true"
      class="pagination-previous"
    >
      Anterior
    </router-link>
    <router-link
      :to="{ name: viewName, params: { id: next } }"
      :disabled="next ? false : true"
      class="pagination-next"
    >
      Siguiente
    </router-link>
  </nav>
</template>

<script>
import store from "../store";
export default {
  props: ["viewName"],
  computed: {
    next() {
      const active = this.state.activeInstance;
      const pivot = this.state.instances.findIndex((e) => e.id == active.id);
      const target = this.state.instances[pivot + 1];
      const index = target ? parseInt(target.id) : null;
      return index;
    },
    previous() {
      const active = this.state.activeInstance;
      const pivot = this.state.instances.findIndex((e) => e.id == active.id);
      const target = this.state.instances[pivot - 1];
      const index = target ? parseInt(target.id) : null;
      return index;
    },
    visible() {
      return Object.keys(this.state.query).length != 0;
    },
  },
  data() {
    return {
      state: store.state,
    };
  },
};
</script>